import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
 deleteItem,
 deleteMultipleItem,
 fetchData,
 handleDragEnd,
 toggleStatus,
} from "../../../utils/apiUtils";
import DeleteModel, {
 confirmBulkDelete,
} from "../../../Components/DeleteModel";
import {
 ActionButton,
 DeleteButton,
 PlusButton,
 ToggleSwitch,
} from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../helper/Breadcrumb";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import dateformate from "../../../helper/DateFormate";
const Cms = () => {
 const navigator = useNavigate();
 const [loading, setLoading] = useState(true);
 const [pageData, setPageData] = useState([]);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [deleteItemId, setDeleteItemId] = useState({});
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const totalPages = Math.ceil(totalCount / perPage);
 const [isDeleting, setIsDeleting] = useState(false);
 const [selected, setSelected] = useState([]);
 const selectAllRef = useRef(null);
 const [nextPosition, setNextPosition] = useState(0);
 const [search, setSearch] = useState("");
 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchCmsData(page);
  }
 };
 const fetchCmsData = async (page = 1, searchQuery = "") => {
  const requestData = {
   perPage: perPage,
   pageNo: page,
   search: searchQuery,
  };
  await fetchData(
   "cms-pagination",
   requestData,
   setPageData,
   setTotalCount,
   setCurrentPage,
   setLoading,
   setNextPosition
  );
 };

 useEffect(() => {
  const delay = search ? 500 : 0;
  const handler = setTimeout(() => {
   fetchCmsData(currentPage, search);
  }, delay);
  return () => clearTimeout(handler);
 }, [search, perPage]);
 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };
 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("cms", deleteItemId?.id, fetchCmsData);
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (error) {
   return error;
  } finally {
   setIsDeleting(false);
  }
 };

 const handleStatusToggle = async (previousdata) => {
  const data = await toggleStatus(
   "cms-status",
   previousdata?.id,
   previousdata?.isActive,
   fetchCmsData
  );
  if (Object.keys(data).length > 0) {
   setPageData((item) =>
    item.map((curr) =>
     curr.id === previousdata.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };
 const handleOnDragEnd = (result) => {
  handleDragEnd({
   result,
   data: pageData,
   setData: setPageData,
   apiEndpoint: "/cms-position",
  });
 };

 const handleEditClick = (item) => {
  navigator("/add-cms", { state: item });
 };

 const handlebulkDelete = async () => {
  await confirmBulkDelete({
   itemType: "CMS",
   selectedIds: selected,
   deleteApiCall: (ids) => deleteMultipleItem("bulk/cms", ids),
   refreshCallback: fetchCmsData,
  });
 };
 //  const handleAdd = () => navigator("/add-cms");
 const handleAdd = () => {
  navigator("/add-cms", { state: { nextPosition } });
 };

 const isAllSelected =
  pageData.length > 0 && selected.length === pageData.length;
 const isIndeterminate =
  selected.length > 0 && selected.length < pageData.length;

 useEffect(() => {
  if (selectAllRef.current) {
   selectAllRef.current.indeterminate = isIndeterminate;
  }
 }, [isIndeterminate]);

 const toggleSelectAll = () => {
  setSelected(isAllSelected ? [] : pageData.map((b) => b.id));
 };

 const toggleSelectOne = (id) => {
  setSelected((prev) =>
   prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
  );
 };

 const Tableheader = ["Page Title","Updated At", "Is Active", "Action"];
 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "CMS", path: "/cms " },
 ];
 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-5">
     <h3 className="custom-page-title">CMS</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
     <PerPageSelect value={perPage} onChange={setPerPage} />

     <div style={{ display: "flex", gap: "20px" }}>
      <TableSearch value={search} onChange={setSearch} />
      <PlusButton handleAdd={handleAdd} module={"CMS"} />
      {selected && selected?.length > 0 && (
       <DeleteButton
        handleAdd={handlebulkDelete}
        name={"selected CMS"}
        module={"cms"}
       />
      )}
     </div>
    </div>

    <div className="row" style={{ marginTop: "0px" }}>
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <DragDropContext onDragEnd={handleOnDragEnd}>
         <Droppable droppableId="sliders">
          {(provided) => (
           <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="table-responsive"
           >
            <table className=" custom-table table table-striped" id="cmstable">
             <thead>
              <tr>
               <th>
                <input
                 type="checkbox"
                 ref={selectAllRef}
                 checked={isAllSelected}
                 onChange={toggleSelectAll}
                />
               </th>
               <th className="font-weight-bold col-2 text-left">Sort Order</th>
               {Tableheader &&
                Tableheader.length > 0 &&
                Tableheader.map((item, index) => (
                 <th className="font-weight-bold col-4 text-left" key={index}>
                  {item}
                 </th>
                ))}
              </tr>
             </thead>
             <tbody>
              {loading ? (
               <tr>
                <td colSpan="7" className="text-center">
                 <Spinner />
                </td>
               </tr>
              ) : pageData.length > 0 ? (
               pageData.map((item, index) => (
                <Draggable
                 key={item.id}
                 draggableId={item.id.toString()}
                 index={index}
                >
                 {(provided) => (
                  <tr
                   ref={provided.innerRef}
                   {...provided.draggableProps}
                   {...provided.dragHandleProps}
                  >
                   <td>
                    <input
                     type="checkbox"
                     checked={selected.includes(item.id)}
                     onChange={() => toggleSelectOne(item.id)}
                    />
                   </td>
                   <td className="text-left col-2">{item.position}</td>
                   <td className="text-left col-4">{item.title}</td>
                   <td className="text-left col-4">{dateformate(item.updatedAt)}</td>
                   {/* <td className="text-left col-4">{dateformate(item.createdAt)}</td> */}
                   <td className="text-left col-4">
                    <ToggleSwitch
                     data={item}
                     name="isActive"
                     checked={item.isActive}
                     handleStatusToggle={handleStatusToggle}
                     module={"CMS"}
                    />
                   </td>

                   <td className="text-left col-4">
                    <ActionButton
                     data={item}
                     handleEditClick={handleEditClick}
                     handleDelete={handleDelete}
                     module={"CMS"}
                    />
                   </td>
                  </tr>
                 )}
                </Draggable>
               ))
              ) : (
               <tr>
                <td colSpan="8" className="text-center">
                 <h5>No data found.</h5>
                </td>
               </tr>
              )}
             </tbody>
            </table>
            {provided.placeholder}
           </div>
          )}
         </Droppable>
        </DragDropContext>

        {pageData.length > 0 && (
         <div>
          <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
         </div>
        )}
       </div>
      </div>
     </div>
    </div>
   </div>

   {deleteModalOpen && (
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="cms"
     isDeleting={isDeleting}
    />
   )}
  </>
 );
};

export default Cms;
